//
//
//
//
//
//
//
//
//
//

/**
 * module contractList
 * author xuyuxiong
 * description 合同列表
 */
import contractList from './list';
import { fetchConstractState } from '@/api/PMS/customerService/leaseContract/contractList';
export default {
  components: {
    contractList: contractList
  },
  data: function data() {
    return {
      title: '',
      activeName: '1',
      list: [],
      // 1：签订、2：正在执行、3：已到期、4：已终止、5：已退租
      tabList: [],
      dialogFormVisible: false,
      listQuery: {}
    };
  },
  created: function created() {
    this.getTabList();
  },
  methods: {
    getTabList: function getTabList() {
      var _this = this;

      fetchConstractState({}).then(function (res) {
        _this.tabList = res.data.data;
      });
    },
    handleUpdateTabList: function handleUpdateTabList() {
      this.getTabList();
    },
    handCancle: function handCancle() {
      this.dialogFormVisible = false;
      this.getTabList();
    }
  }
};